//Globals
import env from '../libs/env';
import Breakpoint from '../libs/breakpoint';

//Modules
// import ScrollMagic from "scrollmagic";
// import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
// import { gsap } from "gsap";

import 'imagesloaded';
import Components from '../modules/Components';

export default {
    init() {
        $('html').addClass('js-active');

        //Add globals to window
        window.env = env;

        // JavaScript to be fired on all pages
        this.breakpoint = new Breakpoint();
        window.bp = this.breakpoint;

        // Init Scroll Magic controler & exposed it
        // window.smCtrl = new ScrollMagic.Controller();
        // ScrollMagicPluginGsap(ScrollMagic, gsap);

        this.components = new Components();
    },
    finalize(fired) {
        // Auto-resize all init route
        $(window).on('resize', () => this.resize(fired));

        //Trigger first resize
		$(window).trigger('resize');
    },
    resize(fired) {
        //Resize Breakpoint
        this.breakpoint.resize();

        //Resize current page js
        fired.forEach(function(value) {
            let cond = (typeof value.resize === 'function');
            if(cond) value.resize();
        });

        //Resize Components
        this.components.resize();
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js